import { Reducer } from "redux";

import { AdGroupType } from "../../../types/adGroupTypes";
import { CampaignCreatorStore } from "../../../types/ReduxTypes/StoreTypes";
import {
  SET_ADGROUP_TEMPLATES,
  SET_ADGROUP_TO_CREATE,
  SET_CAMPAIGN_LANDING_PAGE,
  SET_CAMPAIGN_ROLE_TITLE_COOKIES,
  SET_CAMPAIGN_TO_CREATE_BASIC_DETAILS,
  SET_CAMPAIGN_TO_CREATE_SELECTED_ADVERTISER,
  SET_COMPANY_SORT_VALUES,
  SET_CREATED_CUSTOM_DOMAIN_LIST,
  SET_CUSTOM_DOMAIN_LISTS,
  SET_FOUND_COMPANY_INFO,
  SET_FOUND_HUBSPOT_PAGES,
  SET_FROM_FILE,
  SET_GEO_TARGET_OPTIONS,
  SET_IS_PENDING,
  SET_PRIMARY_SEGMENTS_INCLUDE,
  SET_PUBLIC_DOMAIN_LISTS,
  SET_RESET_CAMPAIGN_TO_CREATE,
  SET_ROLE_TITLE_LIST,
  SET_SELECTED_DOMAIN_LISTS,
  SET_SELECTED_GEO_TARGET_OPTIONS,
  SET_SELECTED_SEGMENT_IDS,
  SET_SELECTED_ZIP_CODES,
  SET_UPDATED_CUSTOM_DOMAIN_LISTS,
  SET_USE_ADGROUP_TEMPLATE,
} from "./types";

const initialState: CampaignCreatorStore = {
  adGroupTemplates: [],
  adGroupToCreate: {
    name: "",
    description: "",
    adGroupType: AdGroupType.IMAGE,
    creativeAssets: [],
  },
  useAdGroupTemplate: true,
  selectedAdGroupTemplate: null,
  basicDetails: {
    showInHubspot: false,
    maxCompanies: "",
    agencyId: "",
    brandgenCampaignId: "",
    createdBy: "",
    description: "",
    endDate: new Date().toString(),
    maxBid: 25,
    name: "",
    startDate: new Date().toString(),
    dailyBudget: "",
    estimatedBudget: 0,
    isVideoCampaign: false,
  },
  campaignCookieSets: null, // Role Title List Selection Result
  landingPage: "", // landingPageSelection
  selectedAdvertiser: null, // selectedAdvertiser
  companySortValues: null, // Select HubSpot Target Companies -> Profile Tiers
  foundCompanyInfo: null, // Select HubSpot Target Companies -> Companies
  fromFile: null,
  foundHubspotPages: [], // Select Landing Page -> Found HubSpot Pages
  geoTargetOptions: [], // Geo Target Options -> State/Province Selection
  roleTitleList: [], // Role Title List Options
  selectedGeoTargetOptions: [], // Selected Geo Target Options -> State/Province Selection
  selectedZipCodes: [], // Selected Zip Codes -> Geo Zip Codes Selection
  selectedSegmentIds: [], // Selected Segments -> Segments Selection
  publicDomainLists: [], // Fetched Public Domain Lists -> Publication Lists Selection
  customDomainLists: [], // Fetched Custom Domain Lists -> Publication Lists Selection
  selectedDomainListsIds: [], // Selected Domain Lists -> Publication Lists Selection
  isPending: false,
};

const campaignToCreateReducer: Reducer<CampaignCreatorStore> = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAMPAIGN_TO_CREATE_BASIC_DETAILS:
      return { ...state, basicDetails: { ...state.basicDetails, ...action.payload } };
    case SET_CAMPAIGN_TO_CREATE_SELECTED_ADVERTISER:
      return { ...state, selectedAdvertiser: action.payload };
    case SET_ADGROUP_TEMPLATES:
      return { ...state, adGroupTemplates: action.payload };
    case SET_COMPANY_SORT_VALUES:
      return { ...state, companySortValues: { ...action.payload } };
    case SET_FOUND_COMPANY_INFO:
      return { ...state, foundCompanyInfo: { ...action.payload } };
    case SET_FROM_FILE:
      return { ...state, fromFile: action.payload };
    case SET_FOUND_HUBSPOT_PAGES:
      return { ...state, foundHubspotPages: action.payload };
    case SET_ROLE_TITLE_LIST:
      return { ...state, roleTitleList: action.payload };
    case SET_GEO_TARGET_OPTIONS:
      return { ...state, geoTargetOptions: action.payload };
    case SET_CAMPAIGN_ROLE_TITLE_COOKIES:
      return { ...state, campaignCookieSets: action.payload };
    case SET_CAMPAIGN_LANDING_PAGE:
      return { ...state, landingPage: action.payload };
    case SET_ADGROUP_TO_CREATE:
      return { ...state, adGroupToCreate: action.payload };
    case SET_USE_ADGROUP_TEMPLATE: {
      const useAdGroupTemplate: boolean = action.payload;
      return {
        ...state,
        useAdGroupTemplate,
        adGroupToCreate: useAdGroupTemplate
          ? {
              name: "",
              description: "",
              adGroupType: AdGroupType.IMAGE,
              creativeAssets: [],
            }
          : state.adGroupToCreate,
      };
    }
    case SET_SELECTED_GEO_TARGET_OPTIONS:
      return { ...state, selectedGeoTargetOptions: action.payload };
    case SET_SELECTED_ZIP_CODES:
      return { ...state, selectedZipCodes: action.payload };
    case SET_SELECTED_SEGMENT_IDS:
      return { ...state, selectedSegmentIds: action.payload };
    case SET_PUBLIC_DOMAIN_LISTS:
      return {
        ...state,
        publicDomainLists: action.payload,
      };
    case SET_CUSTOM_DOMAIN_LISTS:
      return {
        ...state,
        customDomainLists: action.payload,
      };
    case SET_CREATED_CUSTOM_DOMAIN_LIST:
      return {
        ...state,
        customDomainLists:
          state.customDomainLists.length === 0 ? [action.payload] : [...state.customDomainLists, action.payload],
      };
    case SET_UPDATED_CUSTOM_DOMAIN_LISTS:
      return {
        ...state,
        customDomainLists: action.payload,
      };
    case SET_SELECTED_DOMAIN_LISTS:
      return {
        ...state,
        selectedDomainListsIds: action.payload,
      };
    case SET_IS_PENDING:
      return { ...state, isPending: action.payload };
    case SET_RESET_CAMPAIGN_TO_CREATE:
      return {
        ...initialState,
      };
    case SET_PRIMARY_SEGMENTS_INCLUDE:
      return {
        ...state,
        foundCompanyInfo: {
          ...state.foundCompanyInfo,
          primarySegments: state.foundCompanyInfo?.primarySegments?.map((company) =>
            company.domain === action.payload.domain ? { ...company, include: action.payload.include } : company,
          ),
        },
      };
    default:
      return state;
  }
};

export default campaignToCreateReducer;
